/*! multi.js 15-06-2020 */
var multi = function () {
  var e = function e(_e, t, a) {
    var n = _e.options[t.target.getAttribute("multi-index")];

    if (!n.disabled) {
      n.selected = !n.selected;
      var i,
          d,
          l,
          r = a.limit;

      if (r > -1) {
        for (var s = 0, o = 0; o < _e.options.length; o++) {
          _e.options[o].selected && s++;
        }

        if (s === r) {
          this.disabled_limit = !0, "function" == typeof a.limit_reached && a.limit_reached();

          for (o = 0; o < _e.options.length; o++) {
            (c = _e.options[o]).selected || c.setAttribute("disabled", !0);
          }
        } else if (this.disabled_limit) {
          for (o = 0; o < _e.options.length; o++) {
            var c;
            "false" === (c = _e.options[o]).getAttribute("data-origin-disabled") && c.removeAttribute("disabled");
          }

          this.disabled_limit = !1;
        }
      }

      i = "change", d = _e, (l = document.createEvent("HTMLEvents")).initEvent(i, !1, !0), d.dispatchEvent(l);
    }
  },
      t = function t(e, _t) {
    if (e.wrapper.selected.innerHTML = "", e.wrapper.non_selected.innerHTML = "", _t.non_selected_header && _t.selected_header) {
      var a = document.createElement("div"),
          n = document.createElement("div");
      a.className = "header", n.className = "header", a.innerText = _t.non_selected_header, n.innerText = _t.selected_header, e.wrapper.non_selected.appendChild(a), e.wrapper.selected.appendChild(n);
    }

    if (e.wrapper.search) var i = e.wrapper.search.value;

    for (var d = null, l = null, r = 0; r < e.options.length; r++) {
      var s = e.options[r],
          o = s.value,
          c = s.textContent || s.innerText,
          p = document.createElement("a");

      if (p.tabIndex = 0, p.className = "item", p.innerText = c, p.setAttribute("role", "button"), p.setAttribute("data-value", o), p.setAttribute("multi-index", r), s.dataset.subtitle) {
        var u = document.createElement("div");
        u.className = "subtitle", u.innerText = s.dataset.subtitle, p.appendChild(u);
      }

      if (s.disabled && (p.className += " disabled"), s.selected) {
        p.className += " selected";
        var m = p.cloneNode(!0);
        e.wrapper.selected.appendChild(m);
      }

      if ("OPTGROUP" == s.parentNode.nodeName && s.parentNode != l) {
        if (l = s.parentNode, (d = document.createElement("div")).className = "item-group", s.parentNode.label) {
          var h = document.createElement("span");
          h.innerHTML = s.parentNode.label, h.className = "group-label", d.appendChild(h);
        }

        e.wrapper.non_selected.appendChild(d);
      }

      s.parentNode == e && (d = null, l = null), (!i || i && c.toLowerCase().indexOf(i.toLowerCase()) > -1) && (null != d ? d.appendChild(p) : e.wrapper.non_selected.appendChild(p));
    }
  };

  return function (a, n) {
    if ((n = void 0 !== n ? n : {}).enable_search = void 0 === n.enable_search || n.enable_search, n.search_placeholder = void 0 !== n.search_placeholder ? n.search_placeholder : "Search...", n.non_selected_header = void 0 !== n.non_selected_header ? n.non_selected_header : null, n.selected_header = void 0 !== n.selected_header ? n.selected_header : null, n.limit = void 0 !== n.limit ? parseInt(n.limit) : -1, isNaN(n.limit) && (n.limit = -1), null == a.dataset.multijs && "SELECT" == a.nodeName && a.multiple) {
      a.style.display = "none", a.setAttribute("data-multijs", !0);
      var i = document.createElement("div");

      if (i.className = "multi-wrapper", n.enable_search) {
        var d = document.createElement("input");
        d.className = "search-input", d.type = "text", d.setAttribute("placeholder", n.search_placeholder), d.addEventListener("input", function () {
          t(a, n);
        }), i.appendChild(d), i.search = d;
      }

      var l = document.createElement("div");
      l.className = "non-selected-wrapper";
      var r = document.createElement("div");
      r.className = "selected-wrapper", i.addEventListener("click", function (t) {
        t.target.getAttribute("multi-index") && e(a, t, n);
      }), i.addEventListener("keypress", function (t) {
        var i = 32 === t.keyCode || 13 === t.keyCode;
        t.target.getAttribute("multi-index") && i && (t.preventDefault(), e(a, t, n));
      }), i.appendChild(l), i.appendChild(r), i.non_selected = l, i.selected = r, a.wrapper = i, a.parentNode.insertBefore(i, a.nextSibling);

      for (var s = 0; s < a.options.length; s++) {
        var o = a.options[s];
        o.setAttribute("data-origin-disabled", o.disabled);
      }

      t(a, n), a.addEventListener("change", function () {
        t(a, n);
      });
    }
  };
}();

"undefined" != typeof jQuery && function (e) {
  e.fn.multi = function (t) {
    return t = void 0 !== t ? t : {}, this.each(function () {
      var a = e(this);
      multi(a.get(0), t);
    });
  };
}(jQuery);
export default multi;